import { atom } from "recoil";

export const topicsState = atom({
  key: "topicsState",
  default: "",
});
